import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import BackButton from '../../components/BackButton';

const ViewMailDetails = () => {
  const [mailDetails, setMailDetails] = useState(null);
  const [allMailDetails, setAllMailDetails] = useState([]);
  const [filteredDetails, setFilteredDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMailContent, setShowMailContent] = useState(false);
  const [mailContentUrl, setMailContentUrl] = useState("");
  const [activeMenu, setActiveMenu] = useState('viewMailDetails');

  const location = useLocation();
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const queryParams = new URLSearchParams(location.search);
  const mailLogId = queryParams.get('maillogid');

  const BUId = sessionStorage.getItem("BUId");

  useEffect(() => {
    const fetchMailDetails = async () => {
      if (!mailLogId) {
        setError('Mail log ID is missing in the query string');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/Mailer/GetMailDetailsByID?MailLogId=${mailLogId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch mail details by ID');
        }
        const data = await response.json();
        setMailDetails(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchAllMailDetails = async () => {
      try {
        const response = await fetch(`${apiUrl}/Mailer/GetAllMailDetails?BUId=${BUId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch all mail details');
        }
        const data = await response.json();
        setAllMailDetails(data);
      } catch (error) {
        setError(error.message);
      }
    };

    const fetchData = async () => {
      setLoading(true);
      await fetchMailDetails();
      await fetchAllMailDetails();
      setLoading(false);
    };

    fetchData();
  }, [apiUrl, mailLogId]);

  useEffect(() => {
    if (Array.isArray(mailDetails) && mailDetails.length > 0 && allMailDetails.length > 0) {
      const filtered = allMailDetails.filter(
        (mail) => String(mail.mailLogId).trim() === String(mailDetails[0].mailLogId).trim()
      );
      setFilteredDetails(filtered);
    }
  }, [mailDetails, allMailDetails]);
  console.log(mailDetails)
  // Modified handleRedirect function to pass mailDetails and buttonDetails to the next page
  const handleRedirect = (mailLogId, buttonId, mailDetails) => {
    // Find the button details for the clicked button
    const buttonDetails = mailDetails.buttonUrls.find((url) => url.buttonId === buttonId);
    console.log("button", buttonDetails);
    
    // Create a structure that matches what UserLocationDetails expects
    const adaptedMailDetails = {
      // Add any fields that the component might need from mailDetails
      // You can customize this based on what's needed
      id: mailLogId,
      // Add other fields as needed
    };
    
    // Pass mailDetails and buttonDetails as state to the next page
    navigate('/UserLocationDetails', {
      state: { 
        mailDetails: adaptedMailDetails,
        buttonDetails: buttonDetails 
      }
    });
  };
  // const handleViewMailContent = (mailBody) => {
  //   // Assuming `mailBody` contains the URL to the HTML content
  //   const mailContentUrl = mailBody;

  //   // Open the mail content in a new tab
  //   window.open(mailContentUrl, '_blank');
  // };

  const handleViewMailContent = async (url) => {
    setLoading(true);
    setError(null);

    try {
      // We will only load the content URL in the iframe
      setMailContentUrl(url); // Set the URL for iframe source
      setShowMailContent(true); // Show iframe with content
    } catch (err) {
      setError("Failed to load content from the URL");
      setShowMailContent(false); // Hide content if there's an error
    } finally {
      setLoading(false);
    }
  };

  const mailOpenRedirect = (mailLogId, mailDetails) => {
    // Find the button details for the clicked button
    // const buttonDetails = mailDetails.buttonUrls.find((url) => url.buttonId === buttonId);

    // Pass mailDetails and buttonDetails as state to the next page
    navigate('/MailOpenUserDetails', {
      state: { mailDetails }
    });
  };
  console.log(mailDetails);
  if (loading) {
    return (
      <div className="flex items-center justify-center p-8 bg-gray-50 rounded-lg">
        <div className="animate-pulse text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg">
        <div className="flex items-center">
          <p className="text-sm text-red-700">Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <BackButton />

      <div className="max-w-4xl mx-auto space-y-8 p-6">
        <h1 className="text-3xl font-bold text-gray-900 text-center mb-8">
          Mail Log Information
        </h1>

        {filteredDetails.length > 0 && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
              Basic Mail Details
            </h2>
            <div className="space-y-6">
              {filteredDetails.map((mail, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-all duration-300">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      {/* <div>
                        <span className="text-sm font-medium text-gray-500 block mb-1">Mail Log ID</span>
                        <p className="text-gray-900">{mail.mailLogId || 'N/A'}</p>
                      </div> */}
                      <div>
                        <span className="text-sm font-medium text-gray-500 block mb-1">Sender</span>
                        <p className="text-gray-900">{mail.fromEmail || 'N/A'}</p>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <div>
                        <span className="text-sm font-medium text-gray-500 block mb-1">Receiver</span>
                        <p className="text-gray-900">
                          {Array.isArray(mail.toEmail)
                            ? mail.toEmail.join(', ')
                            : typeof mail.toEmail === 'string'
                              ? mail.toEmail.split(',').map(email => email.trim()).join(', ')
                              : 'N/A'}
                        </p>
                      </div>
                      {/* <div>
                        <span className="text-sm font-medium text-gray-500 block mb-1">CC</span>
                        <p className="text-gray-900">
                          {Array.isArray(mail.ccEmail)
                            ? mail.ccEmail.join(', ')
                            : typeof mail.ccEmail === 'string'
                              ? mail.ccEmail.split(',').map(email => email.trim()).join(', ')
                              : 'N/A'}
                        </p>
                      </div> */}
                      {/* <div>
                        <span className="text-sm font-medium text-gray-500 block mb-1">BCC</span>
                        <p className="text-gray-900">
                          {Array.isArray(mail.bccEmail)
                            ? mail.bccEmail.join(', ')
                            : typeof mail.bccEmail === 'string'
                              ? mail.bccEmail.split(',').map(email => email.trim()).join(', ')
                              : 'N/A'}
                        </p>
                      </div> */}
                    </div>
                  </div>
                  {/* Mail Content and View Mail Button */}
                  {/* <div className="mt-6">
                  <span className="text-sm font-medium text-gray-500 block mb-1">Mail Content</span>
                  <p className="text-gray-900 whitespace-pre-wrap bg-white p-4 rounded-lg border border-gray-200">
                    {mail.body || 'N/A'}
                  </p>

                  {mail.body && (
                    <button
                      onClick={() => handleViewMailContent(mail.body)}
                      className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                    >
                      View Mail Content
                    </button>
                  )}
                </div> */}
                  <div className="mt-6">
                    <span className="text-sm font-medium text-gray-500 block mb-1">Mail Content</span>

                    {/* Show iframe when the button is clicked */}
                    {showMailContent && mailContentUrl && (
                      <div className="mt-4">
                        <iframe
                          src={mailContentUrl}
                          width="100%"
                          height="500px"
                          frameBorder="0"
                          title="Mail Content"
                          className="border border-gray-300 rounded-lg"
                        />
                      </div>
                    )}

                    {/* Button to view mail content */}
                    {mail.body && !showMailContent && (
                      <button
                        onClick={() => handleViewMailContent(mail.body)} // Pass the URL (mail.body) to the function
                        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                      >
                        View Mail Content
                      </button>
                    )}

                    {/* Show loading or error if needed */}
                    {loading && <div className="text-gray-600">Loading content...</div>}
                    {error && <div className="text-red-600">{error}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {mailDetails.length > 0 && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 border-b pb-2">
              Track Mail Details
            </h2>
            <div className="space-y-8">
              {mailDetails.map((mail, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-all duration-300">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center">
                      <div>
                        <span className="text-sm font-medium text-gray-500 block mb-2">Mail Open Count</span>
                        <p className="text-2xl font-semibold text-gray-900 mt-1">
                          {mail.mailOpenCount || 0}
                        </p>
                      </div>
                      {/* View Details section */}
                      <a

                        className="text-sm text-blue-500 mt-5 mx-auto inline-block hover:underline"
                        onClick={() => mailOpenRedirect(mail.mailLogId, mail)} // replace with your actual click handler
                      >
                        View
                      </a>
                    </div>


                    <div className="bg-white p-4 rounded-lg shadow-sm">
                      <span className="text-sm font-medium text-gray-500 block">Number of Buttons</span>
                      <p className="text-2xl font-semibold text-gray-900 mt-1">
                        {mail.buttonUrls.length || 0}
                      </p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    {mail.buttonUrls && (
                      <table className="min-w-full table-auto">
                        <thead>
                          <tr className="bg-gray-100 text-left text-sm text-gray-500">
                            <th className="py-2 px-4">Button URL</th>
                            <th className="py-2 px-4">Click Count</th>
                            <th className="py-2 px-4">View Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mail.buttonUrls.map((url, idx) => (
                            <tr key={idx}>
                              <td className="py-2 px-4">{url.buttonURL}</td>
                              <td className="py-2 px-4">{url.clickCount}</td>
                              <td className="py-2 px-4">
                                {url.clickCount > 0 && (
                                  <button
                                    onClick={() => handleRedirect(mail.mailLogId, url.buttonId, mail)}  // Pass both mailLogId, buttonId and mail details
                                    className="text-blue-500 hover:underline"
                                  >
                                    View
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewMailDetails;
